<template>
  <div>
    <headerV/>
    <div class="edit_box flex_box" ref="edit_box">
        <div class="canvas_box">
            <canvas id="RightSaveCanvas"></canvas>
            <canvas id="mask"></canvas>
            <canvas id="cover" style="display: none;"></canvas>
            <canvas id="crop-shade" style="display:none;"></canvas>
        </div>
        <img class="load" src="../assets/images/upload.gif" alt="Load">
        <div class="uploadBox">
            <img src="../assets/images/upload.svg" alt="Upload">
            <label for="upload">{{$t("uploadImage")}}</label>
            <p class="info">{{$t("uploadImageInfo")}}</p>
        </div>
        <img id="fileImage" src="">
    </div>
    <functionDesk/>
    <maskTips/>
    <maskRights/>
    <member/>
    <div class="save_guide">
        <p>{{$t("CropInfo")}}</p>
        <img src="../assets/images/arrow-guide.png" alt="Guide">
    </div>
    <div class="edit_btn flex_box">
        <span class="crop_tab">{{$t("Crop")}}</span>
        <span class="back_remove">{{$t("Back")}}</span>
        <span class="down">{{$t("Download")}}</span>
        <span class="crop_down">{{$t("DownloadCropped")}}</span>
    </div>
    <div class="alert-mask"></div>
  </div>
</template>
<script>
import headerV from "@/components/header"
import functionDesk from "@/components/functionDesk"
import maskTips from "@/components/maskTips"
import maskRights from "@/components/maskRights"
import member from "@/components/member"
import "@/assets/js/member-common.js"
import "@/assets/js/index.js"
export default {
  name: "index",
  components:{
      functionDesk,
      maskTips,
      maskRights,
      member,
      headerV,
  },
  mounted(){
    editInfo=this.$refs.edit_box
    if($(window).width()<=980){
        $('.function_desk_mobile').addClass('active');
        $('.edit_box').css({
            'top':$('.header').outerHeight(true),
            'height':$('.edit_box').outerHeight(true)-$('.header').outerHeight(true)-$('.function_desk_mobile').outerHeight(true)
        });
        $('.function_desk_mobile').removeClass('active');
    }
  }
}
</script>

<style>
    html{background: #F0F7FE;}
    .edit_box{
        position: fixed;
        top: 56px;
        left: 0px;
        width: 100%;
        height: calc(100% - 56px);
        background: #F0F7FE;
    }
    .edit_box .load{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        display: none;
    }
    .edit_box canvas{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    #RightSaveCanvas{
        background-size: cover;
    }
    #mask{
        display: none;
    }
    #cover{
        position: absolute;
        z-index: 10;
        display: none;
    }
    .edit_btn{
        position: fixed;
        bottom: 35px;
        right: 24px;
        display: none !important;
    }
    .edit_btn.active{
        display: flex !important;
    }
    .edit_btn span{
        height: 38px;
        line-height: 38px;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
        background: rgba(241, 247, 254, 0.3);
        border: 1px solid #21a1f2;
        color: #21a1f2;
        display: block;
        text-align: center;
        border-radius: 4px;
        cursor: pointer;
    }
    .edit_btn span:hover{
        background: #33c3f3;
        border-color: #33c3f3;
        color: #fff;
    }
    .edit_btn .crop_tab{
        min-width: 108px;
    }
    .edit_btn .down{
        min-width: 140px;
        background: #21a1f2;
        color: #fff;
        margin-left: 16px;
    }
    .edit_btn .crop_down{
        background: #21a1f2;
        color: #fff;
        margin-left: 16px;
        display: none;
    }
    .edit_btn .back_remove{
        display: none;
    }
    .mask,.alert-mask {
        width: 100%;
        height: 200%;
        position: fixed;
        background: rgba(0, 0, 0, .4);
        top: 0px;
        left: 0px;
        z-index: 2;
        display: none;
    }
    .save_guide.active{display: block !important;}
    .save_guide{
        display: none !important;
        position: fixed;
        bottom: 130px;
        left: auto;
        right: 20px;
        width: 359px;
        min-height: 176px;
        padding-bottom: 10px;
        box-sizing: border-box;
        box-shadow: 0px 4px 18px 0px rgba(123, 123, 123, 0.39);
        border-radius: 18px;
        background: #FBFBFB url(../assets/images/bg.png);
        margin: 0;
    }
    .save_guide img{position: absolute;bottom: -50px;left:200px;}
    .save_guide p{background: none;width: 188px;height: auto;font-size: 14px;line-height: 25px;color: #222;margin-top: 10px;margin-left: 24px;}
    .edit_box>.uploadBox{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        border: 2px dashed #21a1f2;
        border-radius: 16px;
        max-width: 552px;
        width: 95%;
        text-align: center;
        padding-top: 48px;
        padding-bottom: 64px;
        text-align: center;
    }
    .edit_box>.uploadBox img{
        margin: auto;
    }
    .edit_box>.uploadBox label{
        min-width: 220px;
        padding-left: 10px;
        padding-right: 10px;
        line-height: 56px;
        font-size: 18px;
        font-weight: 500;
        color: #fff;
        background: #21a1f2;
        border-radius: 8px;
        display: inline-block;
        margin-top: 8px;
        cursor: pointer;
    }
    .edit_box>.uploadBox label:hover{
        background: #33c3f3;
    }
    .edit_box>.uploadBox p{
        font-size: 16px;
        color: #000;
        line-height: 20px;
        margin-top: 16px;
    }
    .feedback .feedback_container>div p{
        color: #21a1f2;
    }
    .feedback #form_submit{
        background: #21a1f2;
    }
    .feedback #form_submit:hover{
        background: #33c3f3;
        color: #fff;
    }
    @media screen and (max-width:980px){
        .edit_btn.active{
            display: none !important;
        }
        .save_guide{
            max-width: 359px;
            width: 90%;
            bottom: unset;
            top: 120px;
            right: 20px;
            z-index: 9;
        }
        .save_guide img{
            transform: rotate(220deg);
            top:-10px;
            left: unset;
            right: 30px;
        }
        .edit_box{height: 100%;top: 0px;}
    }
    @media screen and (max-width:320px){
        .edit_box>.uploadBox{
            padding-top: 30px;
            padding-bottom: 30px;
        }
    }
</style>